import axiosInstance from './apiClient'
import { getErrorMessage } from '@/lib/utils'

export const fetchTeamChatbots = async (teamId: number) => {
  try {
    const response = await axiosInstance.get(
      `/oge/chatbot/teams/${teamId}/chatbots/`
    )
    return response.data
  } catch (error) {
    throw new Error(getErrorMessage(error))
  }
}

export const fetchRoomTeamChatbots = async (roomId: string) => {
  try {
    const response = await axiosInstance.get(
      `/oge/chatbot/rooms/${roomId}/team-chatbots/`
    )
    return response.data
  } catch (error) {
    throw new Error(getErrorMessage(error))
  }
}

export const createTeamChatbot = async (
  teamId: number,
  assignmentData: { chatbot?: string; base_chatbot: string }
) => {
  try {
    const response = await axiosInstance.post(
      `/oge/chatbot/teams/${teamId}/chatbots/`,
      assignmentData
    )
    return response.data
  } catch (error) {
    throw new Error(getErrorMessage(error))
  }
}

export const updateTeamChatbot = async (
  assignmentId: number,
  assignmentData: { chatbot?: string }
) => {
  try {
    const response = await axiosInstance.put(
      `/oge/chatbot/team-chatbots/${assignmentId}/`,
      assignmentData
    )
    return response.data
  } catch (error) {
    throw new Error(getErrorMessage(error))
  }
}

export const deleteTeamChatbot = async (assignmentId: number) => {
  try {
    const response = await axiosInstance.delete(
      `/oge/chatbot/team-chatbots/${assignmentId}/`
    )
    return response.data
  } catch (error) {
    throw new Error(getErrorMessage(error))
  }
}
